import { useQuery } from '@tanstack/react-query';
import { FIVE_MINUTES_IN_MS } from '@/common/constants';
import { userManagementApi } from '@/features/settings/user-management/api';
import { userManagementQueryKeys } from '@/features/settings/user-management/queryKeys';

export const orgMemberQueryOptions = (userId: string) => ({
  queryKey: userManagementQueryKeys.userManagement.profile(userId),
  queryFn: async () => userManagementApi.getOrgUserById(userId),
  staleTime: FIVE_MINUTES_IN_MS,
});

export const useOrgMemberByIdQuery = (userId: string, enabled = true) => {
  return useQuery({
    ...orgMemberQueryOptions(userId),
    enabled: enabled && !!userId,
  });
};
